import React, { Component } from "react";
import axios from "axios";
import Alert from "react-s-alert";

import { TopTextReusableComponent } from "../../reusableOnboardingComponent/TopTextReusable/TopTextReusableComponent";
import Form from "react-bootstrap/Form";
import {
  // InputBoxComponent,
  // TextAreaReusableComponent,
  NewInputText,
  NewSelectBoxInput,
} from "../../../reusableComponents/inputReusableComponent/InputBoxComponent";
import {
  getCountries,
  getCountryCallingCode,
} from "react-phone-number-input/input";
import en from "react-phone-number-input/locale/en.json";
import {
  ReusableOnboardingLink,
  ReusableOnboardingButton,
} from "../../reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";
import { RestaurantMapSetupValidation } from "../../../../store/validation/allValidationFile/onboardingProcessValidation/RestaurantMapSetupValidation";

import InputNumberFunc from "../../../../function/InputNumberFunc";
import {
  InputCharacterCheck,
  // InputCharNumFunc,
} from "../../../../function/InputCharNumCheckFunc";
import { DropDownBoxCrret } from "../../../reusableComponents/dropDownButtonReusable/DropDownButton";
import { AddButtonIconComponent } from "../../../reusableComponents/buttonReusableComponent/ButtonReusableComponent";
import { SliderReusableComponent } from "../../../reusableComponents/sliderReusableComponent/SliderReusableComponent";
import { BackLogoIconButton } from "../../../reusableComponents/smallReusableComponent/LoginTopLogoAndText";
import { TimeZoneCustom } from "./TimeZoneCustom";
import { CurrencyPicker } from "./CurrencyPicker";
import { AmealioLoader } from "../../../Loader/AmealioLoader";
import countryJson from "../../../localization/country.json";

//import { serverApi } from "../../../../config/Keys";
import isEmpty from "../../../../store/validation/is-Empty";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { clear_all_errors } from "../../../../store/actions/errorActions";
import { create_and_update_restaurant } from "../../../../store/actions/authAction";
import {
  serverApi,
  imageUploadSize,
  videoUploadSize,
} from "../../../../config/Keys";
import { MobileTopHeader } from "../../../reusableComponents/sliderReusableComponent/MobileTopHeader";
import Media from "react-media";
import { SliderMobileReusableComponent } from "../../../reusableComponents/sliderReusableComponent/SliderMobileReusableComponent";
import {
  getAllStateFromCountry,
  getAllCountries,
  getAllCityFromState,
} from "../../../../store/actions/SuperAdminActions/adminCategoryAndIconsAction";
import { FormControl, InputLabel, Select } from "@material-ui/core";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
const validEmailRegex = RegExp(
  /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i
);

export class RestaurantDetailsSettings extends Component {
  fileObj = [];
  fileArray = [];

  constructor(props) {
    super(props);
    this.state = {
      actionButton: false,
      dropDownBox: false,
      localizationText: "",
      hasSetMapProps: false,
      loader: false,
      google_place_id: "",
      name: "",
      address: "",
      pinCode: "",
      area: "",
      city: "",
      businessState: "",
      // location: {
      //   latitude: "",
      //   longitude: "",
      // },
      location: {
        coordinates: ["", ""],
      },
      country_code: "",
      contact_detail: [{ country_code: "", mobile_no: "" }],
      enquiry_email: [""],
      emailError: "",
      phoneError: "",
      country: "",
      currency: "",
      timezone: "",
      errors: {},
      error: null,
      errorValue: false,
      isLoading: false,
      file: null,
      formShow: false,
      data: { country: "", state: "", city: "" },
      countries: [],
      states: [],
      cities: [],
    };
  }

  async componentDidMount() {
    this.props.getAllCountries(this.onSuccessGetAllCountries);
    if (this.props.onboarding._id) {
      this.setState({
        google_place_id: !isEmpty(this.props.onboarding.google_place_id)
          ? this.props.onboarding.google_place_id
          : "",
        address: !isEmpty(this.props.onboarding.restaurant_address)
          ? this.props.onboarding.restaurant_address
          : "",
        city: !isEmpty(this.props.onboarding.city)
          ? this.props.onboarding.city
          : "",
        area: !isEmpty(this.props.onboarding.area)
          ? this.props.onboarding.area
          : "",
        pinCode: !isEmpty(this.props.onboarding.pinCode)
          ? this.props.onboarding.pinCode
          : "",
        businessState: !isEmpty(this.props.onboarding.state)
          ? this.props.onboarding.state
          : "",
        // location: !isEmpty(this.props.onboarding.location)
        //   ? this.props.onboarding.location
        //   : { latitude: "", longitude: "" },
        location:
          !isEmpty(this.props.onboarding.location) &&
          !isEmpty(this.props.onboarding.location.coordinates)
            ? {
                coordinates: [
                  this.props.onboarding.location.coordinates[1],
                  this.props.onboarding.location.coordinates[0],
                ],
              }
            : { coordinates: ["", ""] },

        page_completed_till: 1,

        name: !isEmpty(this.props.onboarding.restaurant_name)
          ? this.props.onboarding.restaurant_name
          : "",
        enquiry_email: !isEmpty(this.props.onboarding.enquiry_email)
          ? this.props.onboarding.enquiry_email
          : [""],
        contact_detail: !isEmpty(this.props.onboarding.contact_detail)
          ? this.props.onboarding.contact_detail
          : [{ country_code: "", mobile_no: "" }],
        country: !isEmpty(this.props.onboarding.country)
          ? this.props.onboarding.country
          : "",
        currency: !isEmpty(this.props.onboarding.currency)
          ? this.props.onboarding.currency
          : "",
        timezone: !isEmpty(this.props.onboarding.timezone)
          ? this.props.onboarding.timezone
          : "",
      });
    }
    this.setState({ isLoading: true });
    axios
      .get("https://ipapi.co/json")
      .then((result) => {
        //console.log(result.data)
        if (!this.state.timezone) {
          this.setState({
            timezone: result.data.timezone,
            isLoading: false,
          });
        }
        if (!this.state.country_code) {
          this.setState({
            currency: result.data.currency,
          });
        }
        // if (!this.state.country) {
        //   this.setState({
        //     country: result.data.country_name,
        //   });
        // }
        if (!this.state.currency) {
          this.setState({
            currency: result.data.currency,
          });
        }
      })
      .catch((error) =>
        this.setState({
          error,
          isLoading: false,
        })
      );

    if (
      this.props.location.state !== null &&
      this.props.location.state !== undefined
    ) {
      if (
        !isEmpty(this.props.location.state.formData.data) !==
          this.state.secondScreen &&
        !isEmpty(this.props.location.state.formData.actionButton) !==
          this.state.actionButton
      ) {
        this.setState({
          secondScreen: this.props.location.state.formData.data,
          actionButton: this.props.location.state.formData.actionButton,
          formShow: true,
        });
      }
    }
  }

  onSuccessGetAllCountries = (allData) => {
    this.setState({ countries: allData });
    //this.setState({...data,country:allData[]})
  };

  componentDidUpdate() {
    if (
      isEmpty(this.state.currency) ||
      isEmpty(this.state.timezone)
    ) {
      axios.get("https://ipapi.co/json").then((result) =>
        //console.log(result.data)
        this.setState({
          country_code: result.data.country_calling_code,
          currency: result.data.currency,
          timezone: result.data.timezone,
          isLoading: false,
        })
      );
    }
    if (this.props.auth.loader !== this.state.loader) {
      this.setState({
        loader: this.props.auth.loader,
      });
    }
  }

  static getDerivedStateFromProps(nextProps, nextState) {
    if (
      nextProps.onboarding._id &&
      nextProps.auth.user.VendorUser &&
      !isEmpty(nextProps.onboarding.location) &&
      !isEmpty(nextProps.onboarding.location.coordinates)
    ) {
      if (
        (!isEmpty(nextProps.onboarding.location) &&
          !isEmpty(nextProps.onboarding.location.coordinates[1]) &&
          !isEmpty(nextProps.onboarding.location.coordinates[0]) &&
          !isEmpty(nextProps.auth.user.VendorUser.country_code) &&
          !nextState.hasSetMapProps) ||
        nextState.location.coordinates[0] !==
          nextProps.onboarding.location.coordinates[1] ||
        nextState.location.coordinates[1] !==
          nextProps.onboarding.location.coordinates[0]
      ) {
        return {
          localizationText: !isEmpty(
            nextProps.auth.user.VendorUser &&
              nextProps.auth.user.VendorUser.country_code &&
              nextProps.auth.user.VendorUser.country
          )
            ? nextProps.auth.user.VendorUser.country_code +
              nextProps.auth.user.VendorUser.country
            : "+91IN",
          google_place_id: !isEmpty(nextProps.onboarding.google_place_id)
            ? nextProps.onboarding.google_place_id
            : "",
          address: !isEmpty(nextProps.onboarding.restaurant_address)
            ? nextProps.onboarding.restaurant_address
            : "",
          // city: !isEmpty(nextProps.onboarding.city)
          //   ? nextProps.onboarding.city
          //   : "",
          area: !isEmpty(nextProps.onboarding.area)
            ? nextProps.onboarding.area
            : "",
          pinCode: !isEmpty(nextProps.onboarding.pinCode)
            ? nextProps.onboarding.pinCode
            : "",
          // businessState: !isEmpty(nextProps.onboarding.state)
          //   ? nextProps.onboarding.state
          //   : "",
          // location: !isEmpty(nextProps.onboarding.location)
          //   ? nextProps.onboarding.location
          //   : { latitude: "", longitude: "" },
          location:
            !isEmpty(nextProps.onboarding.location) &&
            !isEmpty(nextProps.onboarding.location.coordinates)
              ? {
                  coordinates: [
                    nextProps.onboarding.location.coordinates[1],
                    nextProps.onboarding.location.coordinates[0],
                  ],
                }
              : { coordinates: ["", ""] },

          page_completed_till: 1,

          name: !isEmpty(nextProps.onboarding.restaurant_name)
            ? nextProps.onboarding.restaurant_name
            : "",
          enquiry_email: !isEmpty(nextProps.onboarding.enquiry_email)
            ? nextProps.onboarding.enquiry_email
            : [""],
          contact_detail: !isEmpty(nextProps.onboarding.contact_detail)
            ? nextProps.onboarding.contact_detail
            : [{ country_code: "", mobile_no: "" }],
          // country: !isEmpty(nextProps.onboarding.country)
          //   ? nextProps.onboarding.country
          //   : "",
          currency: !isEmpty(nextProps.onboarding.currency)
            ? nextProps.onboarding.currency
            : "",
          timezone: !isEmpty(nextProps.onboarding.timezone)
            ? nextProps.onboarding.timezone
            : "",
          // restaurant_description: !isEmpty(
          //   nextProps.onboarding.restaurant_description
          // )
          //   ? nextProps.onboarding.restaurant_description
          //   : "",
          // logo_url: !isEmpty(nextProps.onboarding.logo_url)
          //   ? nextProps.onboarding.logo_url
          //   : [],
          // restaurant_pictures: !isEmpty(nextProps.onboarding.restaurant_pictures)
          //   ? nextProps.onboarding.restaurant_pictures
          //   : [],
          // restaurant_pictures: [],
          // this.state.restaurant_pictures,
          // things_nearby: nextProps.onboarding.things_nearby,
          hasSetMapProps: true,
        };
      }
    }
    if (nextProps.auth.loader !== nextState.loader) {
      return {
        loader: nextProps.auth.loader,
      };
    }
    if (nextProps.errors !== nextState.errors) {
      return {
        errors: nextState.errors,
      };
    }
    return null;
  }

  /**************************
   * @DESC - ONCHANGE HANDLER
   ***************************/
  handleOnChange = (value) => {
    this.setState({ country_code: "+" + value, actionButton: 3 });
  };

  handleChange = (countryTimeZone) => {
    this.setState({
      timezone: countryTimeZone,
      actionButton: true,
    });
  };

  selecthandleChange = (event) => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  };

  onChange = (e) => {
    this.props.clear_all_errors();
    if (
      e.target.name === "restaurant_description" ||
      e.target.name === "things_nearby"
    ) {
      let caps = e.target.value;
      caps = caps.charAt(0).toUpperCase() + caps.slice(1);
      let dataSet = caps;
      this.setState({
        // [e.target.name]: e.target.value
        [e.target.name]: dataSet,
        actionButton: true,
      });
    } else {
      let data = e.target.value.split(" ");
      let newarray1 = [];
      for (let x = 0; x < data.length; x++) {
        newarray1.push(data[x].charAt(0).toUpperCase() + data[x].slice(1));
      }
      let newData = newarray1.join(" ");
      this.setState({
        [e.target.name]: newData,
        actionButton: true,
      });
    }
  };

  onChangePinCode = (e) => {
    const { value, maxLength } = e.target;
    const number = value.slice(0, maxLength);
    this.setState({
      [e.target.name]: number,
      errors: {},
      actionButton: true,
    });
  };

  onFocusOut = (e) => {
    const { errors } = this.state;
    if (e.target.value === "") {
      errors[
        e.target.name
      ] = `*Fields can’t be blank. Please enter your ${e.target.name}`;
      this.setState({ errorValue: true });
    } else {
      errors[e.target.name] = "";
    }
    this.setState({
      errors: errors,
      actionButton: true,
    });
  };

  onActionButtonClick = (e) => {
    this.props.history.push({
      pathname: "/pointofcontacts",
    });
  };

  // county state city handlers //

  onSuccessGetAllStates = (data) => {
    this.setState({ states: data });
  };

  onSuccessGetAllCity = (data) => {
    this.setState({ cities: data });
  };

  onChangeCountryValue = (e) => {
    const { data, countries } = this.state;

    this.props.getAllStateFromCountry(
      e.target.value,
      this.onSuccessGetAllStates
    );

    this.setState({
      data: { ...data, [e.target.name]: e.target.value, state: "", city: "" },
    });

    for (let i = 0; i < countries.length; i++) {
      if (e.target.value === countries[i].id) {
        this.setState({ country: countries[i].name });
        this.setState({ businessState: '' });
        this.setState({ city: ''});
        break;
      }
    }
  };

  onChangeStateValue = (e) => {
    const { data, states } = this.state;
    const { props, onSuccessGetAllCity } = this;

    props.getAllCityFromState(e.target.value, onSuccessGetAllCity);

    this.setState({
      data: {
        country: data.country,
        [e.target.name]: e.target.value,
        city: "",
      },
    });

    for (let i = 0; i < states.length; i++) {
      if (e.target.value === states[i].id) {
        this.setState({ businessState: states[i].name });
        this.setState({ city: ''});
        break;
      }
    }
  };

  onChangeCityValue = (e) => {
    const { data, cities } = this.state;

    this.setState({
      data: {
        country: data.country,
        state: data.state,
        [e.target.name]: e.target.value,
      },
    });

    for (let i = 0; i < cities.length; i++) {
      if (e.target.value === cities[i].id) {
        this.setState({ city: cities[i].name });
        break;
      }
    }
  };
  // ... Other class methods and render method ...

  /**************************
   * @DESC - ONCHANGE SCREEN HANDLER
   ***************************/
  onChangeScreen = (e) => {
    e.preventDefault();
    if (
      this.props.onboarding &&
      this.props.onboarding.enquiry_email.length > 0
    ) {
      let formData = {
        id: this.props.onboarding._id,
        restaurant_name: this.state.name,
        restaurant_address: this.state.address,
        city: this.state.city,
        area: this.state.area,
        pinCode: this.state.pinCode,
        state: this.state.businessState,
        enquiry_email: this.state.enquiry_email,
        contact_detail: this.state.contact_detail,
        country: this.state.country,
        currency: this.state.currency,
        timezone: this.state.timezone,
      };
      this.props.create_and_update_restaurant(formData);
      this.props.history.push({
        pathname: "/pointofcontacts",
      });
    } else {
      let formData = {
        id: this.props.onboarding._id,
        restaurant_name: this.state.name,
        restaurant_address: this.state.address,
        city: this.state.city,
        area: this.state.area,
        pinCode: this.state.pinCode,
        state: this.state.businessState,
        enquiry_email: this.state.enquiry_email,
        contact_detail: this.state.contact_detail,
        country: this.state.country,
        currency: this.state.currency,
        timezone: this.state.timezone,
        page_completed_till: 2,
      };
      this.props.create_and_update_restaurant(formData);
      this.props.history.push({
        pathname: "/pointofcontacts",
      });
    }
  };

  backbuttonClickhandler = (e) => {
    e.preventDefault();
    this.setState({
      actionButton: true,
    });
  };

  /*****************************************
   * @DESC - Multiple Email Handlers
   ******************************************/
  onEmailAddHandler = (e) => {
    e.preventDefault();
    let enquiry_email = this.state.enquiry_email;
    if (enquiry_email.length >= 5) {
      Alert.error("<h4>Unable Add More Field</h4>", {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 2000,
        offset: 35,
      });
    } else if (
      enquiry_email[enquiry_email.length - 1] === "" ||
      !validEmailRegex.test(enquiry_email[enquiry_email.length - 1])
    ) {
      const { errors, isValid } = RestaurantMapSetupValidation(this.state);
      errors.enquiry_email = "Email is Required";
      if (!isValid) {
        this.setState({
          errors: errors,
        });
      }
    } else {
      enquiry_email.push("");
      this.setState({
        enquiry_email: enquiry_email,
      });
    }
  };

  /*************************************
   * @DESC Email Change Handlers
   ************************************/
  onEmailChangeHandler = (index) => (e) => {
    let enquiry_email = this.state.enquiry_email;
    if (enquiry_email.includes(e.target.value)) {
      alert("Email Already Exits");
    } else {
      enquiry_email[index] = e.target.value;
      this.setState({
        enquiry_email: enquiry_email,
        emailError: "",
        errors: {},
        actionButton: true,
      });
    }
  };

  /*************************************
   * @DESC Email Delete Handlers
   ************************************/
  onEmailDeleteHandler = (index) => (e) => {
    let enquiry_email = this.state.enquiry_email;
    if (enquiry_email.length === 1) {
      Alert.error("<h4>Cannot Delete</h4>", {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 2000,
        offset: 35,
      });
    } else {
      enquiry_email.splice(index, 1);
      this.setState({
        enquiry_email: enquiry_email,
      });
    }
  };

  /*****************************************
   * @DESC - Multiple Phone Handlers
   ******************************************/
  onPhondeAddHandler = (e) => {
    e.preventDefault();
    let contact_detail = this.state.contact_detail;
    if (contact_detail.length >= 5) {
      Alert.error("<h4>Unable Add More Field</h4>", {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 2000,
        offset: 35,
      });
    } else if (
      contact_detail[contact_detail.length - 1].mobile_no === "" ||
      contact_detail[contact_detail.length - 1].mobile_no.length < 9
    ) {
      const { errors, isValid } = RestaurantMapSetupValidation(this.state);
      errors.mobile_no = "Phone is required";
      if (!isValid) {
        this.setState({
          errors: errors,
        });
      }
    } else {
      let obj = {
        country_code: this.state.country_code,
        mobile_no: "",
      };
      contact_detail.push(obj);
      this.setState({ contact_detail: contact_detail });
    }
  };

  /*************************************
   * @DESC Phone Change Handlers
   ************************************/
  onPhoneChangeHandler = (index) => (e) => {
    // let contact_detail = this.state.contact_detail;
    // contact_detail[index].mobile_no = e.target.value.slice(
    //   0,
    //   e.target.maxLength
    // );
    let contact_detail = this.state.contact_detail;
    if (contact_detail.some((diner) => diner.mobile_no === e.target.value)) {
      alert("Phone Number Already Exits");
    } else {
      contact_detail[index].country_code =
        contact_detail[index].country_code === ""
          ? this.state.country_code
          : contact_detail[index].country_code;
      contact_detail[index].mobile_no = e.target.value.slice(
        0,
        e.target.maxLength
      );
      this.setState({
        contact_detail: contact_detail,
        phoneError: "",
        errors: {},
        actionButton: true,
      });
    }
  };

  /*************************************
   * @DESC Country Code Handlers
   ************************************/
  onCountryCodeChangeHandler = (index) => (e) => {
    let contact_detail = this.state.contact_detail;
    contact_detail[index].country_code = e.target.value;
    this.setState({
      contact_detail: contact_detail,
      actionButton: true,
    });
  };

  /*************************************
   * @DESC Phone Number Delete Handlers
   ************************************/
  onPhoneDeleteHandler = (index) => (e) => {
    e.preventDefault();
    let contact_detail = this.state.contact_detail;
    if (contact_detail.length === 1) {
      Alert.error("<h4>Cannot Delete</h4>", {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 2000,
        offset: 35,
      });
    } else {
      contact_detail.splice(index, 1);
      this.setState({ contact_detail: contact_detail, errors: {} });
    }
  };

  /**************************************
   * @DESC - ON IMAGE UPLOAD HANDLER
   * @DESC - USER DEFINED METHODS
   **************************************/
  onImageLogoUploadHandler = (e) => {
    // this.setState({ singleImageLoader: true });
    const vendor_id = this.props.auth.user.VendorUser._id;
    const restaurant_name = this.props.onboarding.restaurant_name
      .split(" ")
      .join("");
    const combined = vendor_id + "_" + restaurant_name;
    const data = new FormData();
    data.append("files", e.target.files[0]);
    if (e.target.files[0].size > imageUploadSize) {
      alert("File is too Big");
    } else {
      axios
        .post(`${serverApi}/upload-assets?uploadSide=${combined}`, data, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((res) => {
          this.setState({
            logo_url: res.data,
            singleImageLoader: false,
            actionButton: true,
          });
          Alert.success(`<h4>Restaurant Logo Upload Successfully</h4>`, {
            position: "top-right",
            effect: "bouncyflip",
            beep: true,
            html: true,
            timeout: 3000,
            offset: 35,
          });
        })
        .catch((err) => {
          // this.setState({ singleImageLoader: false });
          Alert.error(`<h4>Error while uploading the image</h4>`, {
            position: "top-right",
            effect: "bouncyflip",
            beep: true,
            html: true,
            timeout: 3000,
            offset: 35,
          });
        });
    }
  };

  removeFile = (e) => {
    let restaurantLogo = this.state.logo_url;
    restaurantLogo = "";
    this.setState({
      logo_url: restaurantLogo,
      actionButton: true,
    });
  };

  /*************************************
   * @DESC Multiple Image Upload
   ************************************/
  uploadMultipleFiles = (e) => {
    // this.setState({ multipleImageLoader: true });
    const vendor_id = this.props.auth.user.VendorUser._id;
    const restaurant_name = this.props.onboarding.restaurant_name
      .split(" ")
      .join("");
    const combined = vendor_id + "_" + restaurant_name;
    const data = new FormData();
    let flag = false;
    for (let i = 0; i < e.target.files.length; i++) {
      if (e.target.files[i].size > imageUploadSize) {
        alert("File is too Big");
        return (flag = false);
      } else if (e.target.files.length > 10) {
        alert("You can upload only 10 files");
        return (flag = false);
      } else {
        let allPicures = this.state.restaurant_pictures;
        allPicures.some((phone) => {
          if (
            phone.split(`${restaurant_name}-`)[1] === e.target.files[i].name
          ) {
            // console.log("Not Same", phone.split("-")[1]);
            // flag = true;
            return (flag = true);
          } else {
            return (flag = false);
          }
        });
        if (!flag) {
          data.append("files", e.target.files[i]);
        }
      }
    }
    if (!flag) {
      axios
        .post(`${serverApi}/upload-assets?uploadSide=${combined}`, data)
        .then((res) => {
          let oldData = this.state.restaurant_pictures;
          let newData = res.data;
          let mergedData = oldData.concat(newData);
          this.setState({
            restaurant_pictures: mergedData,
            // multipleImageLoader: false,
            actionButton: true,
          });
          Alert.success(`<h4>Restaurant Picture Upload Successfully</h4>`, {
            position: "top-right",
            effect: "bouncyflip",
            beep: true,
            html: true,
            timeout: 3000,
            offset: 35,
          });
        })
        .catch((err) => {
          // this.setState({ multipleImageLoader: false });
          Alert.error(`<h4>${err}</h4>`, {
            position: "top-right",
            effect: "bouncyflip",
            beep: true,
            html: true,
            timeout: 3000,
            offset: 35,
          });
        });
    } else {
      // this.setState({ multipleImageLoader: false });
      Alert.error(`<h4>Can not upload the same image</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
    }
  };

  multipleResetFile = (indexId) => (e) => {
    let allPicures = this.state.restaurant_pictures;
    let allPicuresObj = allPicures.find((images, index) => index === indexId);
    if (allPicuresObj === 0 || allPicuresObj) {
      allPicures.splice(allPicures.indexOf(allPicuresObj), 1);
      this.setState({ allPicures: allPicures, actionButton: true });
    }
  };

  /*************************************
   * @DESC Multiple Video Upload
   ************************************/
  uploadMultipleVideoFiles = (e) => {
    // this.setState({ multipleImageLoader: true });
    const vendor_id = this.props.auth.user.VendorUser._id;
    const restaurant_name = this.props.onboarding.restaurant_name
      .split(" ")
      .join("");
    const combined = vendor_id + "_" + restaurant_name;
    const data = new FormData();
    let flag = false;
    for (let i = 0; i < e.target.files.length; i++) {
      if (e.target.files[i].size > videoUploadSize) {
        alert("File is too Big");
        return (flag = false);
      } else {
        let allPicures = this.state.restaurant_video;
        allPicures.some((phone) => {
          if (
            phone.split(`${restaurant_name}-`)[1] === e.target.files[i].name
          ) {
            // console.log("Not Same", phone.split("-")[1]);
            // flag = true;
            return (flag = true);
          } else {
            return (flag = false);
          }
        });
        if (!flag) {
          data.append("files", e.target.files[i]);
        }
      }
    }
    if (!flag) {
      axios
        .post(`${serverApi}/upload-assets?uploadSide=${combined}`, data)
        .then((res) => {
          let oldData = this.state.restaurant_video;
          let newData = res.data;
          let mergedData = oldData.concat(newData);
          this.setState({
            restaurant_video: mergedData,
            // multipleImageLoader: false,
            actionButton: true,
          });
          Alert.success(`<h4>Restaurant Video Upload Successfully</h4>`, {
            position: "top-right",
            effect: "bouncyflip",
            beep: true,
            html: true,
            timeout: 3000,
            offset: 35,
          });
        })
        .catch((err) => {
          // this.setState({ multipleImageLoader: false });
          Alert.error(`<h4>${err}</h4>`, {
            position: "top-right",
            effect: "bouncyflip",
            beep: true,
            html: true,
            timeout: 3000,
            offset: 35,
          });
        });
    } else {
      // this.setState({ multipleImageLoader: false });
      Alert.error(`<h4>Can not upload the same video</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
    }
  };

  multipleVideoResetFile = (indexId) => (e) => {
    let allPicures = this.state.restaurant_video;
    let allPicuresObj = allPicures.find((images, index) => index === indexId);
    if (allPicuresObj === 0 || allPicuresObj) {
      allPicures.splice(allPicures.indexOf(allPicuresObj), 1);
      this.setState({ allPicures: allPicures, actionButton: true });
    }
  };

  /*********************************
   * @DESC Multiple Image Upload
   ********************************/
  onDrop(picture) {
    this.setState({
      restaurant_pictures: picture,
    });
  }

  /************************************
   * @DESC Drop Down Box Handler
   ***********************************/
  dropDownBoxClick = (e) => {
    e.preventDefault();
    this.setState({
      dropDownBox: !this.state.dropDownBox,
    });
  };

  // async
  handleSubmit = (e) => {
    e.preventDefault();
    if (
      this.props.onboarding &&
      this.props.onboarding.enquiry_email.length > 0
    ) {
      if (this.props.onboarding._id) {
        let formData = {
          id: this.props.onboarding._id,
          restaurant_name: this.state.name,
          restaurant_address: this.state.address,
          city: this.state.city,
          area: this.state.area,
          pinCode: this.state.pinCode,
          state: this.state.businessState,
          enquiry_email: this.state.enquiry_email,
          contact_detail: this.state.contact_detail,
          country: this.state.country,
          currency: this.state.currency,
          timezone: this.state.timezone,
          restaurant_description: this.state.restaurant_description,
          logo_url: this.state.logo_url.toString(),
          restaurant_pictures: this.state.restaurant_pictures,
          things_nearby: this.state.things_nearby,
        };
        // this.props.create_and_update_restaurant(formData);
        // this.props.history.push({
        //   pathname: "/pointofcontacts",
        // });
      }
    } else {
      if (this.props.onboarding._id) {
        let formData = {
          id: this.props.onboarding._id,
          restaurant_name: this.state.name,
          restaurant_address: this.state.address,
          city: this.state.city,
          area: this.state.area,
          pinCode: this.state.pinCode,
          state: this.state.businessState,
          enquiry_email: this.state.enquiry_email,
          contact_detail: this.state.contact_detail,
          country: this.state.country,
          currency: this.state.currency,
          timezone: this.state.timezone,
          restaurant_description: this.state.restaurant_description,
          logo_url: this.state.logo_url.toString(),
          restaurant_pictures: this.state.restaurant_pictures,
          things_nearby: this.state.things_nearby,
          page_completed_till: 2,
        };
        // this.props.create_and_update_restaurant(formData);
        // this.props.history.push({
        //   pathname: "/pointofcontacts",
        // });
      }
    }
  };
  handleFormShow = () => {
    this.setState({ formShow: true });
  };
  handleFormHide = () => {
    this.setState({ formShow: false });
  };
  render() {
    // if (this.state.loader) {
    //   return (
    //     <React.Fragment>
    //       <AmealioLoader />
    //     </React.Fragment>
    //   );
    // }
    const {
      localizationText,
      actionButton,
      errors,
      enquiry_email,
      contact_detail,
      // secondScreen,
      google_place_id,
      name,
      address,
      area,
      city,
      pinCode,
      businessState,
      country,
      currency,
      timezone,
      // restaurant_description,
      // logo_url,
      // restaurant_pictures,
      dropDownBox,
      formShow,
    } = this.state;
    return (
      <React.Fragment>
        <Media query="(max-width: 991px)">
          <>
            {!formShow && (
              <div className="bg-white min-height-100vh position-relative">
                <div className="mobileFirstScreen col-12">
                  <SliderMobileReusableComponent
                    displayShow={true}
                    backLink={true}
                    onLink="/map-setup-two"
                    selectedProgressBarOne="active"
                    paragraphOne="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
                    paragraphTwo="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
                    paragraphThree="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
                    bottomImage={require("../../../../assets/images/illustratorImage/Amealio_Illustrations-06.png")}
                  />
                </div>
                <div className="col-12 py-4">
                  <div className="f24_700_HelveticaNeue">Business Details</div>
                  {/* <div className="f16-400 opacity5">
                    Enter the details about your Business location
                  </div> */}
                </div>
                <div className="border-top d-flex justify-content-center align-items-center p-3 fixed-bottom bg-white">
                  <ReusableOnboardingLink
                    buttonTitle="Back Button"
                    buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_white"
                    buttonText="Back"
                    link="/map-setup-two"
                  />
                  <ReusableOnboardingButton
                    buttonType="button"
                    buttonTitle="Next"
                    buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_red ml-3"
                    buttonText="Next"
                    onClick={this.handleFormShow}
                  />
                </div>
              </div>
            )}
          </>
        </Media>
        <div className={`container-fluid formShow ${formShow ? "active" : ""}`}>
          <div className="row">
            <div
              id="onboarding-scrollbar"
              className="col-12 col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 onboarding_process_screen_left"
            >
              <Media query="(min-width: 992px)">
                <div className="col-12">
                  <BackLogoIconButton
                    displayBackText={true}
                    displayArrow={true}
                    backButtonClicked="/map-setup-two"
                  />
                </div>
              </Media>
              <Media query="(max-width: 991px)">
                <MobileTopHeader onClick={this.handleFormHide} />
              </Media>
              <div className="onboarding_process_screen-left-mapinside">
                <div>
                  <TopTextReusableComponent
                    headingText="Business Details"
                    headingParagraph="Please Enter your Business Information only some of this information is displayed to the end User"
                  />
                </div>
                <Form noValidate>
                  {/* onSubmit={this.handleSubmit} */}
                  <div className="mt-5">
                    <div className="col-12 p-0">
                      <NewInputText
                        extraClass="m-0"
                        name="name"
                        inputType="text"
                        onChange={this.onChange}
                        onFocusOut={this.onFocusOut}
                        value={this.state.name}
                        errorText={errors.name}
                        errorTrue={this.state.name === "" ? true : false}
                        labelText="Business Name*"
                        // helpTextDisplay={true}
                        // helperTextBottom="(Business names on Amealio need to be written as they appear on the board outside the restaurant)"
                        controlClass={
                          errors.name !== ""
                            ? "outlined-error-helper-text"
                            : "outlined-helperText"
                        }
                      />
                      <div
                        className="opacity5 mt-1 mb-4"
                        style={{
                          fontSize: "12px",
                          fontFamily: "Roboto-Regular",
                          color: "#212121",
                          lineHeight: "16px",
                        }}
                      >
                        (Business names on Amealio need to be written as they
                        appear on the board outside the restaurant)
                      </div>
                    </div>
                    <div className="col-12 p-0 text-area-labelText-padding">
                      <NewInputText
                        extraClass="text-area-labelText-padding-two m-0"
                        name="address"
                        onChange={this.onChange}
                        onFocusOut={this.onFocusOut}
                        rows="4"
                        multiline={true}
                        value={this.state.address}
                        errorText={errors.address}
                        errorTrue={this.state.address === "" ? true : false}
                        labelText="Restaurant Address*"
                        controlClass={
                          errors.address !== ""
                            ? "outlined-error-helper-text"
                            : "outlined-helperText "
                        }
                      />
                      <div
                        className="opacity5 mt-1 mb-4"
                        style={{
                          fontSize: "12px",
                          fontFamily: "Roboto-Regular",
                          color: "#212121",
                          lineHeight: "16px",
                        }}
                      >
                        (Business Address on Amealio need to be written to help
                        users navigate to the place, please include all the
                        details )
                      </div>
                    </div>
                    <div className="col-12 my-2 px-0">
                        <FormControl variant="outlined" className="w-100">
                          <InputLabel htmlFor="outlined-Country">
                            Country*
                          </InputLabel>

                          <Select
                            value={this.state.data.country}
                            //value="101"
                            onChange={this.onChangeCountryValue}
                            onBlur ={this.onFocusOut}
                            error={errors.country}
                            label="country"
                            inputProps={{
                              name: "country",
                              id: "outlined-country",
                            }}
                            IconComponent={KeyboardArrowDownIcon}
                          >
                            {this.state.countries.map((country, index) => (
                              <option key={index} value={country.id}>
                                {country.name}
                              </option>
                            ))}
                          </Select>
                          {errors.country &&  (
                              <div className="pho_14_regular text-danger">
                                {errors.country}
                              </div>
                            )}
                        </FormControl>

                        {/* <NewSelectBoxInput
                          selectLabel="Country*"
                          name="country"
                          value={this.state.country}
                          onChange={this.selecthandleChange}
                          getCountries={getCountries}
                          en={en}
                          errorText={errors.country}
                          errorTrue={errors.country === "" ? true : false}
                        /> */}
                      </div>
                    <div className="col-12 p-0">
                      <div className="row">
                        <div className="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                          <NewInputText
                            extraClass="mb-4"
                            name="pinCode"
                            inputType="number"
                            maxLength={
                              countryJson[localizationText] &&
                              countryJson[localizationText].pinCode
                            }
                            onChange={this.onChangePinCode}
                            onFocusOut={this.onFocusOut}
                            onKeyDown={InputNumberFunc}
                            value={this.state.pinCode}
                            errorText={errors.pinCode}
                            errorTrue={this.state.pinCode === "" ? true : false}
                            labelText="Pin/Zip Code*"
                            controlClass={
                              errors.pinCode !== ""
                                ? "outlined-error-helper-text"
                                : "outlined-number"
                            }
                          />
                        </div>
                        <div className="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                          <NewInputText
                            extraClass="mb-4"
                            name="area"
                            inputType="text"
                            onChange={this.onChange}
                            onFocusOut={this.onFocusOut}
                            onKeyDown={InputCharacterCheck}
                            value={this.state.area}
                            errorText={errors.area}
                            errorTrue={this.state.area === "" ? true : false}
                            labelText={
                              countryJson[localizationText] &&
                              countryJson[localizationText].areaCounty + "*"
                            }
                            controlClass={
                              errors.area !== ""
                                ? "outlined-error-helper-text"
                                : "outlined-helperText"
                            }
                          />
                        </div>
                        <div className="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                          {/* <NewInputText
                            extraClass="mb-4"
                            name="city"
                            inputType="text"
                            onChange={this.onChange}
                            onFocusOut={this.onFocusOut}
                            onKeyDown={InputCharacterCheck}
                            value={this.state.city}
                            errorText={errors.city}
                            errorTrue={this.state.city === "" ? true : false}
                            labelText="City*"
                            controlClass={
                              errors.city !== ""
                                ? "outlined-error-helper-text"
                                : "outlined-helperText"
                            }
                          /> */}

                          <FormControl variant="outlined" className="w-100">
                            <InputLabel htmlFor="outlined-Country">
                              city*
                            </InputLabel>

                            <Select
                              value={this.state.data.city}
                              //value="101"
                              onChange={this.onChangeCityValue}
                              className="mb-4"
                              onBlur ={this.onFocusOut}
                              label="cities"
                              inputProps={{
                                name: "city",
                                id: "outlined-cities",
                              }}
                              IconComponent={KeyboardArrowDownIcon}
                              error={errors.city}
                            >
                              {this.state.cities.map((city, index) => (
                                <option key={index} value={city.id}>
                                  {city.name}
                                </option>
                              ))}
                            </Select>
                            {errors.city &&  (
                              <div className="pho_14_regular text-danger">
                                {errors.city}
                              </div>
                            )}
                          </FormControl>
                        </div>
                        <div className="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                          {/* <NewInputText
                            extraClass="mb-4"
                            name="businessState"
                            inputType="text"
                            onChange={this.onChange}
                            onFocusOut={this.onFocusOut}
                            onKeyDown={InputCharacterCheck}
                            value={this.state.businessState}
                            errorText={errors.businessState}
                            errorTrue={
                              this.state.businessState === "" ? true : false
                            }
                            labelText="businessState*"
                            controlClass={
                              errors.businessState !== ""
                                ? "outlined-error-helper-text"
                                : "outlined-helperText"
                            }
                          /> */}
                          <FormControl variant="outlined" className="w-100">
                            <InputLabel htmlFor="outlined-Country">
                              State*
                            </InputLabel>

                            <Select
                              value={this.state.data.state}
                              //value="101"
                              className="mb-4"
                              onChange={this.onChangeStateValue}
                              onBlur ={this.onFocusOut}
                              error={errors.state}
                              label="states"
                              inputProps={{
                                name: "state",
                                id: "outlined-states",
                              }}
                              IconComponent={KeyboardArrowDownIcon}
                            >
                              {this.state.states.map((states, index) => (
                                <option key={index} value={states.id}>
                                  {states.name}
                                </option>
                              ))}
                            </Select>
                            {errors.state &&  (
                              <div className="pho_14_regular text-danger">
                                {errors.state}
                              </div> )}
                          </FormControl>
                        </div>
                      </div>
                    </div>
                    {this.state.enquiry_email.map((email, index) => (
                      <div className="row align-items-center mb-4" key={index}>
                        <div className="col-9">
                          <NewInputText
                            extraClass="mt-0 mb-0"
                            name="enquiry_email"
                            inputType="email"
                            onFocusOut={this.onFocusOut}
                            onChange={this.onEmailChangeHandler(index)}
                            value={email}
                            errorText={
                              !validEmailRegex.test(email) && !isEmpty(email)
                                ? "Please enter a valid email"
                                : null ||
                                  (email === "" &&
                                  errors.enquiry_email === "Email is Required"
                                    ? "*Fields can’t be blank. Please enter your Email"
                                    : null) ||
                                  (email === "" &&
                                    errors.enquiry_email ===
                                      "*Fields can’t be blank. Please enter your enquiry_email")
                                ? "*Fields can’t be blank. Please enter your Email"
                                : ""
                            }
                            errorTrue={
                              (!validEmailRegex.test(email) &&
                                !isEmpty(email)) ||
                              (email === "" &&
                                errors.enquiry_email === "Email is Required") ||
                              (email === "" &&
                                errors.enquiry_email ===
                                  "*Fields can’t be blank. Please enter your enquiry_email")
                                ? true
                                : false
                            }
                            labelText="Enquiry Email*"
                            controlClass={
                              (!validEmailRegex.test(email) &&
                                !isEmpty(email)) ||
                              (email === "" &&
                                errors.enquiry_email === "Email is Required") ||
                              (email === "" &&
                                errors.enquiry_email ===
                                  "*Fields can’t be blank. Please enter your enquiry_email")
                                ? "outlined-error-helper-text"
                                : "outlined-helperText"
                            }
                          />
                        </div>

                        <div className="col-3 restaurant_details_onboarding_minus_button">
                          {this.state.enquiry_email.length > 1 ? (
                            <div>
                              <AddButtonIconComponent
                                buttonText="Delete"
                                onClick={this.onEmailDeleteHandler(index)}
                                fontIcon="fa fa-trash-o"
                                colorCss="delete"
                              />
                            </div>
                          ) : (
                            <div>
                              <AddButtonIconComponent
                                buttonText="Add Another"
                                onClick={this.onEmailAddHandler}
                                fontIcon="fa fa-plus"
                                colorCss="blue"
                              />
                            </div>
                          )}
                        </div>
                      </div>
                    ))}
                    {this.state.enquiry_email.length > 1 ? (
                      <div className="col-12 mb-3 p-0 restaurant_details_onboarding_minus_button add_email_button mt-0">
                        <div>
                          <AddButtonIconComponent
                            buttonText="Add Another Email"
                            onClick={this.onEmailAddHandler}
                            fontIcon="fa fa-plus"
                            colorCss="blue"
                          />
                        </div>
                      </div>
                    ) : null}
                    {/* <Form.Label className="col-12 mt-3 pl-0 restaurant_details_onboarding_mobile_number">
                        Mobile Number
                      </Form.Label> */}
                    {this.state.contact_detail.map((phone, index) => (
                      <div className="row mb-4" key={index}>
                        <div className="col-4 col-xl-3">
                          <Form.Group
                            className="reusableInputComponent-main mb-0"
                            controlId={"country_code"}
                          >
                            <div className="input-phone-country-code-reusable">
                              <select
                                className="w-100"
                                name="country_code"
                                value={phone.country_code}
                                onChange={this.onCountryCodeChangeHandler(
                                  index
                                )}
                              >
                                <option
                                  value={
                                    phone.country_code === ""
                                      ? this.state.country_code
                                      : phone.country_code
                                  }
                                >
                                  {phone.country_code === ""
                                    ? this.state.country_code
                                    : phone.country_code}
                                </option>
                                {getCountries().map((country) => (
                                  <option
                                    key={country}
                                    value={"+" + getCountryCallingCode(country)}
                                    onClick={this.onChangeCountry}
                                  >
                                    {en[country]} (+
                                    {getCountryCallingCode(country)})
                                  </option>
                                ))}
                              </select>
                            </div>
                          </Form.Group>
                        </div>
                        <div className="col-5 col-xl-6 pl-0">
                          <NewInputText
                            extraClass="mb-0"
                            name="mobile_no"
                            inputType="number"
                            onFocusOut={this.onFocusOut}
                            onChange={this.onPhoneChangeHandler(index)}
                            value={phone.mobile_no}
                            maxLength="10"
                            onKeyDown={InputNumberFunc}
                            errorText={
                              phone.mobile_no === "" &&
                              errors.mobile_no === "Phone is required"
                                ? "*Fields can’t be blank. Please enter your valid mobile number"
                                : "" ||
                                  (phone.mobile_no === "" &&
                                    errors.mobile_no ===
                                      "*Fields can’t be blank. Please enter your mobile_no")
                                ? "*Fields can’t be blank. Please enter your valid mobile number"
                                : null ||
                                  (phone.mobile_no.length > 0 &&
                                    phone.mobile_no.length <= 9)
                                ? "Enter your valid mobile number"
                                : null
                            }
                            errorTrue={
                              (phone.mobile_no === "" &&
                                errors.mobile_no === "Phone is required") ||
                              (phone.mobile_no === "" &&
                                errors.mobile_no ===
                                  "*Fields can’t be blank. Please enter your mobile_no") ||
                              (phone.mobile_no.length > 0 &&
                                phone.mobile_no.length <= 9)
                                ? true
                                : false
                            }
                            labelText="Phone Number*"
                            controlClass={
                              (phone.mobile_no === "" &&
                                errors.mobile_no === "Phone is required") ||
                              (phone.mobile_no === "" &&
                                errors.mobile_no ===
                                  "*Fields can’t be blank. Please enter your mobile_no") ||
                              (phone.mobile_no.length > 0 &&
                                phone.mobile_no.length <= 9)
                                ? "outlined-error-helper-text"
                                : "outlined-helperText"
                            }
                          />
                        </div>
                        <div className="col-3 restaurant_details_onboarding_minus_button">
                          {this.state.contact_detail.length > 1 ? (
                            <div>
                              <AddButtonIconComponent
                                buttonText="Delete"
                                onClick={this.onPhoneDeleteHandler(index)}
                                fontIcon="fa fa-trash-o"
                                colorCss="delete"
                              />
                            </div>
                          ) : (
                            <div>
                              <AddButtonIconComponent
                                buttonText="Add Another"
                                onClick={this.onPhondeAddHandler}
                                fontIcon="fa fa-plus"
                                colorCss="blue"
                              />
                            </div>
                          )}
                        </div>
                      </div>
                    ))}
                    {this.state.contact_detail.length > 1 ? (
                      <div className="col-12 pl-0 restaurant_details_onboarding_minus_button add_email_button mt-0">
                        <div>
                          <AddButtonIconComponent
                            buttonText="Add Another Phone Number"
                            onClick={this.onPhondeAddHandler}
                            fontIcon="fa fa-plus"
                            colorCss="blue"
                          />
                        </div>
                      </div>
                    ) : null}
                    <div className="row restaurant_details_onboarding_country_box mb-md-3 mb-lg-3 mb-xl-3 mt-4">
                    
                      <div className="col-3 d-none d-md-block d-lg-block d-xl-block"></div>
                      <div className="col-12 mt-4">
                        <CurrencyPicker
                          name="currency"
                          value={this.state.currency}
                          onChange={this.selecthandleChange}
                          errorTrue={errors.currency === "" ? true : false}
                          errorText={errors.currency}
                        />
                      </div>
                      <div className="col-3 d-none d-md-block d-lg-block d-xl-block"></div>

                      {/* <div className="col-4 col-sm-4 col-md-3 col-lg-3 col-xl-3 restaurant_details_onboarding_country_boxone">
                          <h4>Time Zone</h4>
                        </div>
                        <div className="col-8 col-sm-8 col-md-9 col-lg-9 col-xl-9 restaurant_details_onboarding_country_boxtwo">
                          <div className="restaurant_select_country">
                            <TimeZoneCustom
                              value={this.state.timezone}
                              name={"timezone"}
                              onChange={this.onChange}
                              className="inside_select-box border-0"
                            />
                            <Form.Text className="text-muted input-component-bottom">
                              {errors ? (
                                <div className="text-danger text-capitalize">
                                  {errors.timezone}
                                </div>
                              ) : null}
                            </Form.Text>
                          </div>
                        </div> */}
                    </div>
                    <div className="row restaurant_details_onboarding_country_box mb-md-3 mb-lg-3 mb-xl-3 mt-4">
                      <div className="col-12">
                        <TimeZoneCustom
                          name="timezone"
                          value={this.state.timezone}
                          onChange={this.onChange}
                          errorTrue={errors.timezone === "" ? true : false}
                          errorText={errors.timezone}
                        />
                      </div>
                      {/* <div className="f14-500">{this.state.timezone}</div> */}
                      <div className="col-3 d-none d-md-block d-lg-block d-xl-block"></div>
                    </div>
                    <hr />
                    <div className="row ">
                      <div className="col-12 map-button-box-main">
                        <DropDownBoxCrret
                          state={dropDownBox}
                          showText="See less details"
                          hideText="See more details"
                          onClick={this.dropDownBoxClick}
                        />
                        {dropDownBox ? (
                          <div className="col-12 p-0 mt-4 location-detections-popup-main h-50">
                            <div className="location-detections-popup-bodyBox">
                              <h5 className="col-12 p-0 d-flex location-detections-popup-headingfive">
                                Place ID:{" "}
                                <p className="location-detections-popup-paragraphfive">
                                  {google_place_id}
                                </p>
                              </h5>
                              <div className="row justify-content-between mt-4">
                                <div className="col-6">
                                  <NewInputText
                                    inputType="number"
                                    value={parseFloat(
                                      this.state.location.coordinates[0]
                                    ).toFixed(5)}
                                    labelText="Lattitude"
                                    disabled={true}
                                  />
                                </div>
                                <div className="col-6">
                                  <NewInputText
                                    inputType="number"
                                    value={parseFloat(
                                      this.state.location.coordinates[1]
                                    ).toFixed(5)}
                                    labelText="Longitude"
                                    disabled={true}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        ) : null}
                      </div>
                    </div>
                    <div className="onboarding-map-setup-screen-autodetect-button">
                      {/* <div className="onboarding-map-setup-screen-autodetect-button-inside"> */}
                      <Media query="(min-width: 992px)">
                        <ReusableOnboardingLink
                          buttonTitle="Back Button"
                          buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_white"
                          buttonText="Back"
                          link="/map-setup-two"
                        />
                      </Media>
                      <Media query="(max-width: 991px)">
                        <ReusableOnboardingButton
                          buttonTitle="Back Button"
                          buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_white"
                          buttonText="Back"
                          buttonType="button"
                          onClick={this.handleFormHide}
                        />
                      </Media>
                      <ReusableOnboardingButton
                        buttonTitle="Next Button"
                        buttonText="Next"
                        onClick={
                          actionButton === false
                            ? this.onActionButtonClick
                            : this.onChangeScreen
                        }
                        buttonClass={
                          name === "" ||
                          address === "" ||
                          area === "" ||
                          city === "" ||
                          pinCode === "" ||
                          businessState === "" ||
                          country === "" ||
                          currency === "" ||
                          timezone === "" ||
                          enquiry_email[0] === "" ||
                          contact_detail[0].mobile_no === "" ||
                          contact_detail[0].mobile_no.length <= 9 ||
                          contact_detail[contact_detail.length - 1]
                            .mobile_no === "" ||
                          contact_detail[contact_detail.length - 1].mobile_no
                            .length <= 9 ||
                          enquiry_email[enquiry_email.length - 1] === "" ||
                          !validEmailRegex.test(enquiry_email[0])
                            ? "onboarding_button_link_reusable onboarding_button_link_reusable_gray ml-3"
                            : "onboarding_button_link_reusable onboarding_button_link_reusable_red ml-3"
                        }
                        disabled={
                          name === "" ||
                          address === "" ||
                          area === "" ||
                          city === "" ||
                          pinCode === "" ||
                          businessState === "" ||
                          country === "" ||
                          currency === "" ||
                          timezone === "" ||
                          enquiry_email[0] === "" ||
                          contact_detail[0].mobile_no === "" ||
                          contact_detail[0].mobile_no.length <= 9 ||
                          contact_detail[contact_detail.length - 1]
                            .mobile_no === "" ||
                          contact_detail[contact_detail.length - 1].mobile_no
                            .length <= 9 ||
                          enquiry_email[enquiry_email.length - 1] === "" ||
                          !validEmailRegex.test(enquiry_email[0])
                            ? true
                            : false
                        }
                      />
                      {/* </div> */}
                    </div>
                  </div>
                </Form>
              </div>
            </div>
            <div className="col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 loginsignup-rightside">
              <SliderReusableComponent
                displayBarButton={true}
                displayHamburger={true}
                selectedProgressBarOne="active"
                paragraphOne="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
                paragraphTwo="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
                paragraphThree="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
                bottomImage={require("../../../../assets/images/illustratorImage/Amealio_Illustrations-06.png")}
              />
            </div>
            {/* <div className="col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 onboarding_process_screen_right">
              <RightSidePannel
                selectedTab={this.state.selectedTab}
                headingText="Store Setup"
                imageSrc={require("../../../../assets/images/onboarding/storeSetup.svg")}
                paragraph="Enter information diligently about your food establishment. Users
                  would like to know about your restaurant listed on our app. Take your
                  time and fill information carefully"
              />
            </div> */}
          </div>
        </div>
      </React.Fragment>
    );
  }
}

RestaurantDetailsSettings.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  getAllCountries: PropTypes.func.isRequired,
  getAllStateFromCountry: PropTypes.func.isRequired,
  getAllCityFromState: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
  storage: state.storage,
  onboarding: state.onboarding.restaurantDetails,
});

export default connect(mapStateToProps, {
  clear_all_errors,
  create_and_update_restaurant,
  getAllStateFromCountry,
  getAllCityFromState,
  getAllCountries,
})(withRouter(RestaurantDetailsSettings));

//03-09-2020
